import clsx from "clsx";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Icon } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PageRoute from "../../../constant/pageRouteDictionary.json";

const useStyles = makeStyles(theme => ({
  editLink: {
    color: theme.palette.common.link,
    fontSize: 12,
    textDecoration: "none",
  },
  editIcon: {
    marginRight: 5,
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 11,
  },
}));

const OrganizeWorkspacesLink = () => {
  const classes = useStyles();

  return (
    <Link to={PageRoute.ORGANIZE_WORKSPACES} className={classes.editLink}>
      <Icon className={clsx(["fa fa-edit", classes.editIcon])} />
      <FormattedMessage id="product.edit" />
    </Link>
  );
};

export default OrganizeWorkspacesLink;
